var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "v-height-flag" },
      [
        _c(
          "el-card",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingBox,
                expression: "loadingBox",
              },
            ],
            staticClass: "mb14 normal-page",
            attrs: { "body-style": { padding: "20px 20px 20px 20px" } },
          },
          [
            _c("oaFromBox", {
              attrs: {
                title: _vm.$route.meta.title,
                search: _vm.search,
                dropdownList: _vm.dropdownList,
                total: _vm.total,
                isViewSearch: false,
                sortSearch: false,
              },
              on: { dropdownFn: _vm.dropdownFn, confirmData: _vm.confirmData },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-box mt10" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      height: _vm.tableHeight,
                      "row-key": "id",
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "ID", type: "" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "字典名称",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ident",
                        label: "字典标识",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "type",
                        label: "状态",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  disabled: scope.row.is_default === 1,
                                  "active-text": "启用",
                                  "inactive-text": "停用",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleStatus(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.status,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "status", $$v)
                                  },
                                  expression: "scope.row.status",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "mark",
                        label: "备注",
                        "min-width": "150",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.mark || "--")),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "created_at",
                        label: "创建时间",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.created_at || "--")),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        label: _vm.$t("public.operation"),
                        width: "250",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.is_default !== 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editFn(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dataFn(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("数据管理")]
                              ),
                              _vm._v(" "),
                              scope.row.is_default !== 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-fixed" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "page-size": _vm.where.limit,
                        "current-page": _vm.where.page,
                        "page-sizes": [15, 20, 30],
                        layout: "total, sizes,prev, pager, next, jumper",
                        total: _vm.total,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.pageChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }